<template>
	<figure :class="[sizeClass, { portrait: isPortrait }]">
		<div
			v-if="cropped"
			:class="['avatar', { rounded: isRounded }]"
			:style="`background-image: url(${avatar})`"
		>
			<img :src="avatar" :alt="alt" />
		</div>
		<img v-else :src="avatar" :alt="alt" />
	</figure>
</template>
<script>
export default {
	props: {
		image: {
			type: String,
			required: true
		},
		alt: {
			type: String,
			default: ""
		},
		size: {
			type: String,
			default: "is-128x128",
			required: false
		},
		cropped: {
			type: Boolean,
			default: false
		},
		isRounded: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		sizeClass() {
			return ["image", this.size];
		},
		avatar() {
			return this.image
				? this.image
				: `${this.coreurl}/avatar/${this.initials}.png`;
		},
		initials() {
			var nameSplit = String(this.alt).toUpperCase().split(" ");
			let initials = "?";

			if (nameSplit.length === 1) {
				initials = nameSplit[0].charAt(0);
			} else {
				initials = nameSplit[0].charAt(0) + nameSplit[1].charAt(0);
			}

			return initials;
		},
		dimensions() {
			let image = new Image();
			if (this.image) {
				image.src = this.image;
				const { width, height } = image;
				return { width, height };
			}
			return false;
		},
		isPortrait() {
			const { width, height } = this.dimensions;
			return width < height;
		},
		isLandscape() {
			const { width, height } = this.dimensions;
			return width > height;
		},
		coreurl() {
			return process.env.VUE_APP_SERVICES;
		}
	}
};
</script>

<style lang="scss" scoped>
.avatar {
	width: 100%;
	height: 100%;
	background-position: 50% 50%;
	background-size: cover;

	&.rounded {
		border-radius: 50%;
	}

	img {
		visibility: hidden;
	}
}

.image.is-256x256 {
	height: 256px;
	width: 256px;
}
.image {
	text-align: left;
	&.is-16-high,
	&.is-24-high,
	&.is-32-high,
	&.is-48-high,
	&.is-64-high,
	&.is-96-high,
	&.is-128-high,
	&.is-158-high {
		width: auto;
		img {
			height: 100%;
			width: auto;
		}
	}
	&.is-16-high {
		height: 16px;
	}
	&.is-24-high {
		height: 24px;
	}
	&.is-32-high {
		height: 32px;
	}
	&.is-48-high {
		height: 48px;
	}
	&.is-64-high {
		height: 64px;
	}
	&.is-96-high {
		height: 96px;
	}
	&.is-128-high {
		height: 128px;
	}
	&.is-158-high {
		height: 158px;
	}
	&.is-contained {
		max-width: 200px;
		max-height: 200px;

		&.portrait {
			width: 200px;
			height: 200px;
		}

		img {
			width: 100%;
			height: 100%;
			object-fit: contain;
		}
	}
}
</style>
